require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-2018-06-15-football-draft-point-scoring-system.json") })
        }
      }, "path---blog-2018-06-15-football-draft-point-scoring-system");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-2018-06-15-football-draft-point-scoring-system!./.cache/json/blog-2018-06-15-football-draft-point-scoring-system.json
// module id = 333
// module chunks = 231608221292675